import { useEffect, useRef, useState } from "react";
import type * as type from "@vTypes"
import * as mutate from "@script/mutate"
import { v4 as uuidv4 } from 'uuid';

export default function MgmtTableRowNewNurse_excel(
    {
        fullNurseSchema,
        preceptorList,
        order,
        excelData,
        setExcelData,
        excelValidation,
        fetchNurseSchema,
        willSaveCheck,
        setWillSaveCheckList,
        
    } : {
        fullNurseSchema: type.FullNurseSchema[];
        preceptorList : {nurse_id : string, name : string}[];
        order: number;
        excelData: type.FullNurseSchema[];
        setExcelData: React.Dispatch<React.SetStateAction<type.FullNurseSchema>>;
        excelValidation: type.ParsingExcelData;
        fetchNurseSchema: ()=>void;
        willSaveCheck: boolean;
        setWillSaveCheckList: React.Dispatch<React.SetStateAction<boolean[]>>;

        
    }
){

    
    const [isTypeListOpend, setIsTypetListOpend] = useState<boolean>(false);
    const [isPreceptorListOpend, setIsPreceptorListOpend] = useState<boolean>(false);

  
//    const [copyNurse, setCopyNurse] = useState<type.FullNurseSchema>(parsingExcelItem.nurse_data)

    const preceptorName="없음"
    // const preceptorName = filterPreceptorName();
    const joiningDate = filterDate(excelData.joining_date);
    const resignationDate = filterDate(excelData.resignation_date);

/* 임시 함수 */
    const dutyArray = ["-", "데이", "이브닝", "나이트"];
    const [nurseNumber, setNurseNumber] = useState<string>("000");
    const [typeIndex, setTypeIndex] = useState<number>(0);
/* //임시 함수 */

    function filterPreceptorName(){
        const name = preceptorList?.filter(n=>n.nurse_id === excelData.preceptor_id)[0]?.name;
        return name ? name : "없음";
    }
    function filterDate(date:Date){
        // DB 저장형태 : 2000-00-00T00:00:00
        return date? String(date).split("T")[0] : "";
    }
    
    const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		adjustTextareaHeight(e.target);
	};
    const adjustTextareaHeight = (element: HTMLTextAreaElement) => {
		element.style.height = 'auto';
		element.style.height = element.scrollHeight + 'px';
	};
    const trBackground = excelValidation.is_valid ? "" : "comp_tr--error";
    return(
        <div className={`comp_tr comp_tr--hover comp_tr--excel ${trBackground} `}>
            {/* <div className="comp_td">
                <div className="comp_btn_dragHandler"><span className="img_iconHandler"></span></div>
            </div> */}
            <div className="comp_td">
                {excelValidation.is_valid 
                    ?(
                    <label className="comp_inputCheck">
                        <input type="checkbox" 
                            checked={willSaveCheck ?? false}
                            onChange={e=>{
                                const isChecked = e.currentTarget.checked;
                                setWillSaveCheckList(prev=>
                                    prev.map((bool, index)=> (index === order ? isChecked : bool) )
                                );
                            }}
                        />
                        <span className="com_inputCheck_checkIcon"></span>
                    </label>
                    ) :(<div className="hoverMessageWrap">
                        <span className="warnIcon">!</span>
                        <div className="hoverMessage">
                            {excelValidation.errors.map((text, index)=>{
                                return (
                                    <p key={index}>{text}</p>
                                )
                            })}
                        </div>
                    </div>)
                }
                

            </div>

            <div className="comp_td">
                <input type="text" 
                    className="comp_inputText"
                    value={nurseNumber}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value;
                        setNurseNumber(changeValue);
                    }}
                    onBlur={e=>{
                        const changeValue = e.currentTarget.value;
                        if(changeValue === ""){
                            alert("사번을 입력해주세요");
                            setNurseNumber("000");
                            e.currentTarget.focus();
                        }
                    }}
                />
            </div>

            <div className="comp_td">
                <input type="text" 
                    className="comp_inputText"
                    value={excelData.account_id}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value;
                        // setExcelData(prev=>({...prev, account_id : changeValue}));
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, account_id : changeValue}
                                : item
                            })
                        );
                    }}
                    // onBlur={e=>{
                    //     const changeValue = e.currentTarget.value;
                    //     if(changeValue === ""){
                    //         alert("아이디를 입력해주세요");
                    //         setCopyNurse(prev=>({...prev, account_id : "ID"}));
                    //         e.currentTarget.focus();
                    //     }
                    // }}
                />
            </div>

            
            <div className="comp_td">
                <input type="text" 
                    className="comp_inputText"
                    value={excelData.name}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value;
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, name : changeValue}
                                : item
                            })
                        );
                    }}
                    // onBlur={e=>{
                    //     const changeValue = e.currentTarget.value;
                    //     if(changeValue === ""){
                    //         alert("이름을 입력해주세요");
                    //         setCopyNurse(prev=>({...prev, name : "New Nurse"}));
                    //         e.currentTarget.focus();
                    //     }
                    // }}
                />
            </div>
            <div className="comp_td">
                <input type="text" 
                    className="comp_inputText"
                    value={excelData.level_}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value;
                        // setCopyNurse(prev=>({...prev, level_ : changeValue}));
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, level_ : changeValue}
                                : item
                            })
                        );
                    }}
                />
            </div>


            <div className="comp_td">
                <label className={`conf_slideSwitch `}>
                    <input type="checkbox"
                        checked={excelData.is_head_nurse}
                        onChange={e=>{
                            const changeValue = e.currentTarget.checked;
                            // setCopyNurse(prev=>({...prev, is_head_nurse : changeValue}))
                            setExcelData(prev=>
                                prev.map((item, index)=>{
                                    return index === order
                                    ? {...item, is_head_nurse : changeValue}
                                    : item
                                })
                            );
                        }}
                    
                    />
                    <span className="conf_switchHandler"></span>
                </label>
            </div>
            
            <div className="comp_td">
                <input type="text" 
                    className="comp_inputText"
                    value={excelData.experience}
                    onChange={e=>{
                        const changeValue = Number(e.currentTarget.value);
                        // setCopyNurse(prev=>({...prev, experience : changeValue}));
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, experience : changeValue}
                                : item
                            })
                        );
                    }}
                />
            </div>

            <div className="comp_td">
                <div className="conf_selectType_wrap">
                    <button type="button" className="conf_selectType conf_selectType--button"
                        onClick={()=>{setIsTypetListOpend(prev=>!prev)}}
                    >
                        {dutyArray[typeIndex]}
                    </button>
                    {isTypeListOpend &&
                        <div className="conf_selectType_list">
                            {
                                dutyArray.map((type, index)=>{
                                    
                                    // const isSelected = false;
                                    const isSelected = index === typeIndex;
                                    return (
                                        <button key={index} type="button"
                                            className={`conf_selectType_item ${isSelected && "selected"}`}
                                            onClick={()=>{
                                                setIsTypetListOpend(false);
                                                setTypeIndex(index)
                                            }}
                                        >
                                            {type}
                                        </button>            
                                    )
                                })
                            }
                        </div>
                    }
                </div>
            </div>
            <div className="comp_td">
                <div className="conf_selectType_wrap">
                    <button type="button" className="conf_selectType conf_selectType--button"
                        onClick={()=>{setIsPreceptorListOpend(prev=>!prev)}}
                    >
                        {preceptorName}
                    </button>
                    {isPreceptorListOpend &&
                        <div className="conf_selectType_list">
                            <button type="button"
                                className={`conf_selectType_item ${preceptorName === "없음" && "selected"}`}
                                onClick={()=>{
                                    // setCopyNurse((prev)=>({...prev, preceptor_id: null}));
                                    setExcelData(prev=>
                                        prev.map((item, index)=>{
                                            return index === order
                                            ? {...item, preceptor_id: null}
                                            : item
                                        })
                                    );
                                    setIsPreceptorListOpend(false);
                                }}
                            >
                                없음
                            </button>
                            {
                                preceptorList
                                    .filter(n => n.nurse_id !== excelData.account_id) // 자기 자신 제외
                                    .map((n, index)=>{
                                        const isSelected = n.nurse_id === excelData.preceptor_id;
                                        return (
                                            <button type="button" key={n.nurse_id}
                                                className={`conf_selectType_item ${isSelected && "selected"}`}
                                                onClick={()=>{
                                                    // setCopyNurse((prev)=>({...prev, preceptor_id: n.nurse_id}));
                                                    setExcelData(prev=>
                                                        prev.map((item, index)=>{
                                                            return index === order
                                                            ? {...item, preceptor_id: n.nurse_id}
                                                            : item
                                                        })
                                                    );
                                                    setIsPreceptorListOpend(false);
                                                }}
                                            >
                                                {n.name}
                                            </button>
                                        )
                                    })
                            }
                        </div>
                    }
                </div>
            </div>
            <div className="comp_td">
                <input type="date" className="comp_inputDate comp_inputDate--input"
                    value={joiningDate}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value === "" ? null : e.currentTarget.value + "T00:00:00";
                        // setCopyNurse(prev=>({...prev, joining_date : changeValue}))
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, joining_date : changeValue}
                                : item
                            })
                        );
                    }}
                />
            </div>

            <div className="comp_td">
                {/* 적용 해제일 (퇴사일) */}
                <input type="date" className="comp_inputDate comp_inputDate--input"
                    value={resignationDate}
                    onChange={e=>{
                        const changeValue = e.currentTarget.value === "" ? null : e.currentTarget.value + "T00:00:00";
                        // setCopyNurse(prev=>({...prev, resignation_date : changeValue}))
                        setExcelData(prev=>
                            prev.map((item, index)=>{
                                return index === order
                                ? {...item, resignation_date : changeValue}
                                : item
                            })
                        );
                    }}
                />
            </div>
            <div className="comp_td mgmt_table__td--memo">
                <textarea name="" id="" rows={1} 
                    className="comp_textArea comp_textArea--textarea"
                    onChange={handleTextareaChange}
                    value={""}
                >
                </textarea>
            </div>
            {/* <div className="comp_td">
                <button type="button" className="comp_btn_editMode" onClick={()=>{}}>삭제</button>
            </div> */}
        </div>
    )

}
